import { useData } from 'vike-react/useData'
import type { Data } from './+data'
import HomePage from '../../src/pages/HomePage'

/**
 * SSR homepage. Renders HomePage inside ShopChromeLayout (SSR-safe router, i18n,
 * query client, chrome) with the category + featured data server-fetched in
 * +data, so the hero, static copy AND the category/featured grids are all in the
 * server HTML.
 */
export default function HomeSsrPage() {
  const { categories, featured } = useData<Data>()
  return <HomePage initialCategories={categories} initialFeatured={featured} />
}
